// ConfirmModal - Reusable confirmation modal for destructive actions
// Removed autoFocus to maintain consistent behavior across the application
import { AlertTriangle, Info } from 'lucide-react';
import { Modal } from './Modal';
import Button from './Button';

interface ConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  variant?: 'danger' | 'default';
  loading?: boolean;
}

export function ConfirmModal({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmLabel = 'Confirmer',
  cancelLabel = 'Annuler',
  variant = 'default',
  loading = false,
}: ConfirmModalProps) {
  const isDanger = variant === 'danger';
  const Icon = isDanger ? AlertTriangle : Info;
  const iconBgColor = isDanger ? 'bg-error-100' : 'bg-primary-100';
  const iconColor = isDanger ? 'text-error-600' : 'text-primary-600';

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={title} size="sm">
      <div className="space-y-6">
        <div className="flex items-start gap-4">
          <div className={`${iconBgColor} rounded-xl p-3 flex-shrink-0`}>
            <Icon className={`w-6 h-6 ${iconColor}`} />
          </div>
          <p className="text-base text-neutral-700 leading-relaxed flex-1 pt-1">
            {message}
          </p>
        </div>

        <div className="flex gap-3 justify-end">
          <Button
            variant="secondary"
            onClick={onClose}
            disabled={loading}
          >
            {cancelLabel}
          </Button>
          <Button
            variant={isDanger ? 'danger' : 'primary'}
            onClick={onConfirm}
            loading={loading}
          >
            {confirmLabel}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
